import { Route } from 'react-router-dom';
import Incidents from '@/modules/common/pages/Incidents.tsx';
import Meetings from '@/modules/common/pages/Meetings.tsx';
import SecretManager from '@/modules/common/pages/SecretManager.tsx';
import SecretManagerVault from '@/modules/common/pages/SecretManagerVault.tsx';
// import Reports from '@/modules/common/pages/Reports.tsx';
import EmployeeDashboardWrapper from '@/modules/employee-dashboard/components/EmployeeDashboardWrapper.tsx';
import Dashboard from '@/modules/employee-dashboard/pages/Dashboard.tsx';
import Tasks from '@/modules/employee-dashboard/pages/Tasks.tsx';

export const employeeDashboardPaths = {
  static: {
    dashboard: '/employee/dashboard',
    tasks: '/employee/tasks',
    reports: '/employee/reports',
    incidents: '/employee/events',
    aiChat: '/employee/ai-chat',
    meetings: '/employee/meetings',
    secretManager: '/employee/secret-manager',
  },
  dynamic: {
    taskCategory(category?: string) {
      return `/employee/tasks/${category || ':category'}`;
    },
    secretVault(vaultId?: string | number) {
      return `/employee/secret-manager/${vaultId || ':vaultId'}`;
    },
  },
};

export const getEmployeeDashboardRoutes = () => {
  return (
    <Route element={<EmployeeDashboardWrapper />}>
      <Route path={employeeDashboardPaths.static.dashboard} element={<Dashboard />} />
      <Route path={employeeDashboardPaths.static.tasks} element={<Tasks />} />
      <Route path={employeeDashboardPaths.dynamic.taskCategory()} element={<Tasks />} />
      <Route path={employeeDashboardPaths.static.meetings} element={<Meetings />} />
      <Route path={employeeDashboardPaths.static.secretManager} element={<SecretManager />} />
      <Route
        path={employeeDashboardPaths.dynamic.secretVault()}
        element={<SecretManagerVault />}
      />
      {/*<Route path={employeeDashboardPaths.static.reports} element={<Reports />} />*/}
      <Route
        path={employeeDashboardPaths.static.incidents}
        element={<Incidents hideAddIncidentTypeButton />}
      />
    </Route>
  );
};
